import Page from '@components/pageComponent/page.js';
import controller from './controller.js';

export default class App {
  constructor() {
    this.page = new Page();
  }

  start() {
    this.page.mount();
    controller.init();
  }
}
